import { DataApiResponse } from '../../../contract/base/Response';
import { User } from '../../../contract/identity/User';
import axiosInstance from '../../../utils/axios';
import { handleError } from '../../base/baseService';

type CreateEmailAddressVerificationToken = {
  emailAddress: string;
};

export async function createEmailAddressVerificationToken(request: CreateEmailAddressVerificationToken) {
  try {
    const response = await axiosInstance.post<DataApiResponse<User>>('/users/self/email-confirmation-token', request);

    return response.data;
  }
  catch (error) {
    return handleError(error);
  }
}